'use strict';

var slicedToArray = require('../../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../../Styles/withStyles.js');
require('prop-types');
var ObjectHelper = require('../../../../common/ObjectHelper.js');
var Button = require('../../../Inputs/Buttons/Button/Button.js');
var ArrowDropdown = require('../../../../IconsAndImages/Icons/ArrowDropdown.js');
var FranchiseesMenu = require('./FranchiseesMenu.js');
var Popover = require('../../../../node_modules/@material-ui/core/esm/Popover/Popover.js');
var MenuList = require('../../../../node_modules/@material-ui/core/esm/MenuList/MenuList.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    companyLogoGridWidth: {
      maxWidth: 72
    },
    companyLogoButton: {
      marginLeft: -12,
      marginRight: 4,
      padding: 6
    },
    companyLogoSize: {
      maxHeight: 42,
      '& img': {
        maxHeight: 42,
        maxWidth: 62
      }
    }
  };
};

var CompanyLogoButton = function CompanyLogoButton(_ref) {
  var classes = _ref.classes,
      companyLogo = _ref.companyLogo,
      franchisees = _ref.franchisees;
      objectWithoutProperties(_ref, ["classes", "companyLogo", "franchisees"]);

  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      franchiseesMenuOpen = _useState2[0],
      setFranchiseesMenuOpen = _useState2[1];

  var _useState3 = React.useState(null),
      _useState4 = slicedToArray(_useState3, 2),
      franchiseesMenuAnchor = _useState4[0],
      setFranchiseesMenuAnchor = _useState4[1];

  var handleFranchiseesMenuOpen = function handleFranchiseesMenuOpen(event, open) {
    setFranchiseesMenuAnchor(event.currentTarget);
    setFranchiseesMenuOpen(open);
  };

  return React__default["default"].createElement(React.Fragment, null, ObjectHelper.isPresent(companyLogo) && React__default["default"].createElement(Button["default"], {
    color: "inherit",
    className: classes.companyLogoButton,
    onClick: function onClick(event) {
      return handleFranchiseesMenuOpen(event, true);
    }
  }, React__default["default"].createElement("span", {
    className: classes.companyLogoSize
  }, companyLogo), React__default["default"].createElement(ArrowDropdown, null)), React__default["default"].createElement(Popover["default"], {
    open: franchiseesMenuOpen,
    anchorEl: franchiseesMenuAnchor,
    anchorReference: "anchorEl",
    onClose: function onClose(event) {
      handleFranchiseesMenuOpen(event, false);
    },
    anchorOrigin: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  }, React__default["default"].createElement(MenuList, null, React__default["default"].createElement(FranchiseesMenu, {
    franchisees: franchisees
  }))));
};

CompanyLogoButton.defaultProps = {
  companyLogo: null
};
var CompanyLogoButton$1 = withStyles["default"](styles)(CompanyLogoButton);

module.exports = CompanyLogoButton$1;
